import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ApiError } from "./api/errors";
import { router } from "./router";
import { applyTheme, normalize } from "./theme/themes";
import "./styles/app.css";

// Apply the saved theme (the inline head script already did, before first paint)
// and keep following the OS while in "Match system".
try {
  applyTheme(normalize(JSON.parse(localStorage.getItem("sub.theme") ?? "{}")));
} catch {
  applyTheme(normalize({}));
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Reads retry twice with back-off; never retry what the API refused on purpose.
      retry: (count, err) => count < 2 && !(err instanceof ApiError && err.status >= 400 && err.status < 500),
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
